import React, { Fragment } from 'react';

const Qr = ({ style = {}, classes = [], children, qr}) => {
  // let qrNew= "https://coincaex.com/API/PQR/?Key=M2UyZjYyNTdjMGIzYzM3YWEwNmI1YzliNjJmMGVjN2I&data=ethereum%3Apay-0x2cfc85d8e48f8eab294be644d9e25c3030863003%40480%2Ftransfer%3Faddress%3D0xe2D5114DFFEEECaCdD979E53A7F9f95de1660c72%26uint256%3D2.42000000100606e18%22"
  return (
    <div
      style={{
        backgroundImage: `url(${qr})`,
        // backgroundSize: 'cover',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        width: '60vw', 
        // minHeight: '15vh',
        height: '25vh',
        // top: '-10px',
        // left: '1rem',
        position: 'relative', 
        overflow: 'hidden',   // Evita scroll si el contenido sale
        ...style,
      }}
    >  
    </div>
  );
};

export const SetQr = ({ style = {}, classes = [], children, qr }) => (
    <Fragment>
        <Qr {...{ style, classes: [...classes, 'stack'], children, qr }}/>
    </Fragment>
);
